import { useQuery, useQueryClient } from 'react-query';
import useAxiosInstance from '../useXdmAxiosInstance';
import { getXdmEntityAllData } from '../../services/XdmService';
import { XdmEntityObject } from '../../models';

export default function useGetXdmEntitiesDataQuery(entities: string[]) {
  const { axios } = useAxiosInstance();
  const queryClient = useQueryClient();

  return useQuery<{ [key: string]: XdmEntityObject[] }>(
    [entities.join(',')],
    () => {
      return new Promise<{ [key: string]: XdmEntityObject[] }>(
        async (resolve, reject) => {
          try {
            const promises = entities.map(
              (e) =>
                new Promise(async (resolve, reject) => {
                  try {
                    const cachedData = queryClient.getQueryData([e]);
                    if (cachedData) {
                      resolve(cachedData);
                      return;
                    }

                    resolve(await getXdmEntityAllData(axios, e));
                  } catch (e) {
                    reject(e);
                  }
                })
            );

            const results = await Promise.all(promises);
            entities.forEach((e, i) => {
              queryClient.setQueryData([e], () => results[i]);
            });

            resolve(
              entities.reduce(
                (prev, curr, index) => ({
                  ...prev,
                  [curr]: results[index],
                }),
                {}
              )
            );
          } catch (err) {
            console.error(err);
            reject();
          }
        }
      );
    }
  );
}
